var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphologiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1121.543,
    height: 792.516,
    viewBox: "0 0 1121.543 792.516",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-1014 -610.447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M612.988,575.146a36.173,36.173,0,0,0,50.324-.806l31.077-31.061a36.238,36.238,0,0,0,0-51.223L555.5,353.183l-82.268,82.254Z",
    transform: "translate(1101.525 489.039)",
    fill: "#97d700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M914.912,900.478l-80.976,80.961L587.254,734.756,603.912,718.1,805.146,516.849l28.79-28.79,82.222,82.19,82.269-82.269L859.555,349.092a36.236,36.236,0,0,0-51.222,0L448.287,709.136a36.239,36.239,0,0,0,0,51.224l360.046,360.045a36.237,36.237,0,0,0,51.222,0L998.427,981.517l-82.253-82.254Z",
    transform: "translate(576.314 271.956)",
    fill: "#97d700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M746.925,616.726a36.238,36.238,0,0,0,0-51.223l-57.847-57.866-81.024-81.023.016-.031-56.634-56.649c-.222-.206-.442-.38-.663-.585a36.193,36.193,0,0,0-50.56.585L469.15,400.995a36.206,36.206,0,0,0-.142,51.066l139.03,139.03-.031.031,82.255,82.255.03-.017Z",
    transform: "translate(884.482 580.098)",
    fill: "#13294b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 116.341,
    height: 116.367,
    transform: "translate(1492.472 842.197) rotate(-45)",
    fill: "#13294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M1023.419,709.136,663.373,349.092a36.3,36.3,0,0,0-51.271,0L473.231,487.98l82.286,82.285,82.19-82.206.031.031.032-.031,246.7,246.7L637.738,981.47,531.349,875.079l-.158.159a36.122,36.122,0,0,1-1.294,49.63L473.262,981.5l-.031.015L612.1,1120.389a36.258,36.258,0,0,0,51.271,0l360.046-360.046A36.19,36.19,0,0,0,1023.419,709.136Z",
    transform: "translate(1101.511 271.956)",
    fill: "#00a9e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M510.385,460.424c.22.206.441.38.661.585l56.635,56.65,82.206-82.206L567.6,353.182,461.276,459.493l.172.191A36.082,36.082,0,0,1,510.385,460.424Z",
    transform: "translate(924.869 489.023)",
    fill: "#00a9e0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphologiIcon);
export default __webpack_public_path__ + "static/media/GraphologiIcon.a8345a0bb36c92869cf86f6f3914500e.svg";
export { ForwardRef as ReactComponent };